import styled from "styled-components"

import { mobile, tablet, tabletl, hd } from '../responsive'

export const Main = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  
  ${mobile ({ flexDirection: "column"})}
`

export const Left = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mobile({ width: "100%" })}

`

export const Slika = styled.img`
  width: 70%;
  height: 70%;
  object-fit: contain;
`

export const Right = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${mobile({ width: "100%", textAlign: "center" })}
  ${hd({  })}
`

export const Ime = styled.div`
  width: 100%;
  height: 35%;
  display: flex;
  align-items: center;

  p {
    
    font-size: 28px;
    color: teal;
    font-weight: bold;

    ${mobile({ fontSize: "22px" })}
    ${tablet({ fontSize: "28px" })}
  }

  ${mobile({ justifyContent: "center"})}
`

export const Stanje = styled.div`

  ${mobile({ height: "15%", justifyContent: "center" })}
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;

  p {
    font-size: 18px;
    
    ${mobile({ fontSize: "16px" })}
    ${tablet({ fontSize: "16px" })}
  }

  b {
    color: teal;
  }
`

export const Kompatibilnost = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;

  ${mobile({ height: "20%", textAlign: "center", justifyContent: "center" })}

  p {
    font-size: 18px;

    ${mobile({ fontSize: "14px" })}
    ${tablet({ fontSize: "16px" })}
  }

  b {
    color: teal;
  }
`

export const Ispis = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;

  ${mobile({ height: "20%", justifyContent: "center" })}

  p {
    font-size: 18px;

    ${mobile({ fontSize: "14px" })}
    ${tablet({ fontSize: "16px" })}
  }

  b {
    color: teal;

    ${mobile({ fontSize: "14px", color: "teal" })}
    ${tablet({ fontSize: "16px" })}
  }
`

export const CijenaDiv = styled.div`
  width: 100%;
  height: 20%;
  display: flex;

  ${mobile({ justifyContent: "center", flexDirection: "column", width: "100%", alignItems: "center" })}
`

export const Cijena = styled.div`
  width: 20%;
  height: 40%;
  display: flex;
  align-items: center;

  ${mobile({ width: "100%" })}
  ${tablet({ width: "50%" })}
  ${tabletl({ width: "30%" })}

  p {
    font-size: 18px;

    ${mobile({ fontSize: "14px", width: "100%" })}
    ${tablet({ fontSize: "16px" })}
  }

  b {
    color: teal;
  }
`

export const Mail = styled.div`
  width: 50%;
  height: 40%;
  display: flex;
  align-items: center;
  justify-content: center; 

  ${mobile({ width: "80%" })}
`

export const Button = styled.button`
  width: 60%;
  height: 40px;
  font-size: 16px;
  color: white;
  border: 1px solid transparent;
  background-color: teal;
  border-radius: 10px;

  ${mobile({ marginTop: "20%", marginRight: "20%" })}
  ${tabletl({ fontSize: "12px", width: "60%", marginLeft: "10%" })}

  &:hover{
    cursor: pointer;
  }
`